import { RawFilterItem } from "@/components/molecules/FiltersActive/filtersData";
import { cross as crossIcon } from "@/icons";
import clsx from "clsx";
import React from "react";

const FilterPill: React.FC<{ item: RawFilterItem }> = ({ item }) => {
  return (
    <div
      className="flex rounded-full w-fit px-2.5 h-9 bg-action-secondary-default hover:bg-action-secondary-hover text-white cursor-pointer whitespace-nowrap"
      onClick={item.onClick}
      role="button"
      tabIndex={0}
      aria-label={item.alt}
    >
      <div className="flex items-center gap-1.5">
        <div
          className={clsx(
            "h-7 w-7 flex items-center justify-center",
            item.alt === "Rating Range" && "w-fit",
          )}
        >
          {item.icon}
        </div>
        {item.alt !== "market" && <div className="h-3 w-3">{crossIcon}</div>}
      </div>
    </div>
  );
};

export default FilterPill;
